
let getters = {
    getUser:({user}) => {
        return user;
    },
}

export default getters
